import {
  IconArmchair,
  IconBarrel,
  IconBath,
  IconBed,
  IconBike,
  IconBriefcase,
  IconBuilding,
  IconBuildingCommunity,
  IconBuildingCottage,
  IconBuildingWarehouse,
  IconCar,
  IconCarGarage,
  IconChefHat,
  IconDeviceTv,
  IconDoor,
  IconDoorEnter,
  IconFlower,
  IconHanger,
  IconHorse,
  IconLadder,
  IconMoodKid,
  IconParking,
  IconPlant2,
  IconShoe,
  IconSofa,
  IconStairs,
  IconStairsUp,
  IconSwimming,
  IconToiletPaper,
  IconTool,
  IconTools,
  IconTrash,
  IconTree,
  IconUsersGroup,
  IconWashMachine,
  IconWindow,
  IconBooks,
  IconBottle,
  IconFlame,
  IconSun,
  IconToolsKitchen2,
  IconBarbell,
} from '@tabler/icons-react';

import { RoomType } from 'src/types/cartography.types';

/** Une icône par type de pièce : le pictogramme est le premier repère de lecture. */
export const ROOM_ICONS: Record<RoomType, typeof IconDoor> = {
  [RoomType.BEDROOM]: IconBed,
  [RoomType.MASTER_BEDROOM]: IconBed,
  [RoomType.DORMITORY]: IconBed,
  [RoomType.STUDIO_APARTMENT]: IconBuilding,
  [RoomType.DRESSING_ROOM]: IconHanger,
  [RoomType.STORAGE_ROOM]: IconShoe,

  [RoomType.LIVING_ROOM]: IconSofa,
  [RoomType.DINING_ROOM]: IconArmchair,
  [RoomType.OFFICE]: IconBriefcase,
  [RoomType.LIBRARY]: IconBooks,
  [RoomType.PLAYROOM]: IconMoodKid,
  [RoomType.GYM]: IconBarbell,
  [RoomType.HOME_CINEMA]: IconDeviceTv,
  [RoomType.VERANDA]: IconWindow,
  [RoomType.RECEPTION_ROOM]: IconUsersGroup,

  [RoomType.KITCHEN]: IconChefHat,
  [RoomType.PANTRY]: IconToolsKitchen2,
  [RoomType.LAUNDRY]: IconWashMachine,
  [RoomType.LARDER]: IconBottle,

  [RoomType.BATHROOM]: IconBath,
  [RoomType.SHOWER_ROOM]: IconBath,
  [RoomType.POWDER_ROOM]: IconToiletPaper,
  [RoomType.TOILET]: IconToiletPaper,

  [RoomType.ENTRANCE]: IconDoorEnter,
  [RoomType.HALLWAY]: IconDoor,
  [RoomType.LANDING]: IconStairs,
  [RoomType.STAIRWELL]: IconStairs,
  [RoomType.MEZZANINE]: IconLadder,
  [RoomType.ATTIC]: IconStairsUp,
  [RoomType.BASEMENT]: IconStairs,
  [RoomType.CELLAR]: IconBarrel,
  [RoomType.WINE_CELLAR]: IconBottle,
  [RoomType.BOILER_ROOM]: IconFlame,

  [RoomType.OUTDOOR]: IconTree,
  [RoomType.GARDEN]: IconFlower,
  [RoomType.TERRACE]: IconSun,
  [RoomType.BALCONY]: IconWindow,
  [RoomType.LOGGIA]: IconWindow,
  [RoomType.COURTYARD]: IconPlant2,
  [RoomType.POOL]: IconSwimming,
  [RoomType.POOL_HOUSE]: IconSwimming,

  [RoomType.GARAGE]: IconCarGarage,
  [RoomType.CARPORT]: IconCar,
  [RoomType.PARKING_SPACE]: IconParking,
  [RoomType.WORKSHOP]: IconTools,
  [RoomType.SHED]: IconTool,
  [RoomType.OUTBUILDING]: IconBuildingCottage,
  [RoomType.BARN]: IconBuildingWarehouse,
  [RoomType.STABLE]: IconHorse,

  [RoomType.COMMON_AREA]: IconBuildingCommunity,
  [RoomType.LOBBY]: IconDoorEnter,
  [RoomType.BIKE_ROOM]: IconBike,
  [RoomType.BIN_ROOM]: IconTrash,

  [RoomType.OTHER]: IconDoor,
};
